import { Result } from "../../models/result";
import { AttendanceReport } from "../../models/attendance_report";
import { agentEndpoints } from "../apiConfig";
import httpRepo from "../httpRepo";

export const getFullYearAttendanceReportForClass = async (params) => {
    /**
     * @param {Object} params
     * @param {string} params.academicYear 
     * @param {string} params.schoolId 
     * @param {string} params.userId 
     * @param {number} params.Class 
     * @param {string} params.sec 
     * @param {boolean} params.isFullYearReport 
     */
    try {
        const responseData = await httpRepo.post(agentEndpoints.getAttendance, params);
        if (responseData && responseData.success && Array.isArray(responseData.value)) {
            responseData.value = responseData.value.map(item => AttendanceReport.fromJson(item));
        }
        return new Result(responseData);
    } catch (ex) {
        return new Result({
            message: `Error [getFullYearAttendanceReportForClass]: ${ex.message}`,
        });
    }
}
